// extracted by mini-css-extract-plugin
export var accordion = "_ax-0";
export var chevron = "_ax-3";
export var closed = "_ax-2";
export var content = "_ax-4";
export var open = "_ax-1";
export var rotate = "_ax-5";